module.exports = __webpack_public_path__ + "static/media/BackOffice.ce5a57c2.png";